import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2","key":"svg-1"}],["path",{"d":"M13 15l1 1","key":"svg-2"}]]

const IconSquareLetterQ = createReactComponent('outline', 'square-letter-q', 'SquareLetterQ', __iconNode);

export default IconSquareLetterQ;